// extracted by mini-css-extract-plugin
export default {"titleContainer":"titleContainer___gyFzX","list":"list___WNZGp","listItem":"listItem___S7lUy","deleteContainer":"deleteContainer___xHkcF"};